/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_AromaInputs */

const en_edit_aroma = /** @type {(inputs: Edit_AromaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Aroma`)
};

const es_edit_aroma = /** @type {(inputs: Edit_AromaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar aroma`)
};

/**
* | output |
* | --- |
* | "Edit Aroma" |
*
* @param {Edit_AromaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const edit_aroma = /** @type {((inputs?: Edit_AromaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_AromaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_edit_aroma(inputs)
	return es_edit_aroma(inputs)
});